import { useState } from 'react';

/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-06-04 14:31:15
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-06-06 15:30:00
 */
export default () => {
  const [showAddContract, setShowAddContract] = useState({
    open: false,
    type: 1,
  });

  const [showPreview, setShowPreview] = useState(false);
  const [showUpdateContract, setShowUpdateContract] = useState(false);

  return {
    showAddContract,
    setShowAddContract,
    showPreview,
    setShowPreview,
    showUpdateContract,
    setShowUpdateContract,
  };
};
